/**
 * Экраны входа и регистрации — вне общего шелла: ни sidebar, ни навигации.
 * Тот же тёмный нейтральный фон, интерфейс минимальный (§85).
 */
import { Link, Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="flex min-h-full flex-col items-center justify-center bg-page px-5 py-12">
      <div className="w-full max-w-[400px]">
        <Link to="/" className="mb-8 block text-center text-card-title font-semibold tracking-tight">
          Alterium
        </Link>
        <Outlet />
      </div>
    </div>
  );
}
